<template>
  <!-- card mode -->
  <v-card class="roma-card full-h roma-elevation-3">
    <v-card-text class="full-h">
      <v-container class="pa-0">
        <!-- header -->
        <v-row no-gutters="" class="d-flex justify-end mb-5" >
          <div elevation="0" cols="auto" class="ml-5" x-small rounded
            :class="{
              'pendiente-bg': evaluation.estadoEvaluacion == 0 || evaluation.estadoEvaluacion == 4,
              'en-progreso-bg': evaluation.estadoEvaluacion == 1,
              'completa-evaluada-bg': evaluation.estadoEvaluacion == 2 || evaluation.estadoEvaluacion == 3
            }">
            <!-- <v-btn text rounded x-small class="text-capitalize romaGreyCard"> -->
              
              <h5 class="font-inter subtitulo-5" :style="{ color: '#3a8fce' }" v-if="evaluation.estadoEvaluacion == 0">PENDIENTE</h5>
              <h5 class="font-inter subtitulo-5" :style="{ color: '#ff9102' }" v-if="evaluation.estadoEvaluacion == 1">EN PROGRESO</h5>
              <h5 class="font-inter subtitulo-5" :style="{ color: '#4caf50' }" v-if="evaluation.estadoEvaluacion == 2">COMPLETA</h5>
              <h5 class="font-inter subtitulo-5" :style="{ color: '#4caf50' }" v-if="evaluation.estadoEvaluacion == 3">EVALUADA</h5>
              <h5 class="font-inter subtitulo-5" :style="{ color: '#3a8fce' }" v-if="evaluation.estadoEvaluacion == 4">PENDIENTE</h5>
              <!-- <span v-if="evaluation.estadoEvaluacion == 2">ENPROCESO</span> -->
              <!-- {{ evaluation.estadoEvaluacion }} -->
            <!-- </v-btn> -->
          </div>

          <div class="ml-3"
            ><h5 class="font-inter font-weight-500 parrafo-2">
              {{ formatDate(evaluation.fechaMedicionAsignada) }}
            </h5>
          </div>

          
        </v-row>

        <v-row no-gutters class="mb-1">
            <v-col>
              <span class="ml-3 px-2 subtitulo-5 py-1 px-2 font-inter" :style="{ color: '#743085', background: '#F1E6FF', 'border-radius': '8px'}">
                {{this.user().section.category.abbreviation}}
                </span>
            </v-col>
        </v-row>

        <!-- subheader -->
        <v-row no-gutters class="mb-5">
          <v-col>            
            <strong v-if="evaluation.contextoAcademico === 0" class="roma-card__subject px-3 titulo-5 color-neutro-0">
              {{ capitalizeFirstLetter(evaluation.nombreAsignatura.toLowerCase()) }}
            </strong>
          </v-col>
        </v-row>

        <v-row no-gutters="" class="mt-1 ml-3 mb-1">
          <v-col cols="auto">
            <span class="font-inter subtitulo-2 color-neutro-1">
              {{
                evaluation.codigoEvaluacion
              }}
            
            </span>
          </v-col>
        </v-row>

        <v-row no-gutters="" class="ml-3 mb-14">
           <v-col cols="auto">      
                <span
                  title="Evaluación Progresiva Diagnostica"
                  class="font-inter titulo-3 color-neutro-0"
                >
                  {{ textCapitalize(evaluation.nombreEvaluacion) }}
                </span>
                
          </v-col>
        </v-row>
        

        <!-- footer -->
         <v-row no-gutters="" class="card-container-footer mb-4" >
            <v-col cols="12" class="d-flex justify-end">
                <v-btn
                    v-if="evaluation.estadoEvaluacion == 2 ||
                    evaluation.estadoEvaluacion == 3"

                    class="text-capitalize text-right"
                    rounded
                    text
                    :href="getURLtoRedirect(evaluation)"
                    target="_blank"

                    >
                      <!-- <span v-if="evaluation.estadoEvaluacion == 1">Iniciar</span> -->
                      <span v-if="evaluation.estadoEvaluacion == 2" class="color-purpura-base parrafo-2 font-weight-600">Listo</span>
                      <span v-if="evaluation.estadoEvaluacion == 3" class="color-purpura-base parrafo-2 font-weight-600">Ver Resultados</span>
                      <!-- <span v-if="evaluation.estadoEvaluacion == 4">Iniciar</span> -->
                    </v-btn>
                <v-btn
                    v-if="evaluation.estadoEvaluacion == 0 && 
                    evaluation.estadoMedicionAsignada == 5"
                    dark 
                    class="primary-btn text-capitalize text-right"
                    :href="getURLtoRedirect(evaluation)"
                    target="_blank"

                    >
                  <span class="parrafo-2 font-weight-600">Iniciar</span>
                </v-btn>


                <v-btn
                    v-if="evaluation.estadoEvaluacion == 1 && 
                    evaluation.estadoMedicionAsignada == 5"
                    dark 
                    class="primary-btn text-capitalize text-right"
                    :href="getURLtoRedirect(evaluation)"
                    target="_blank"
                    elevation="1"

                    >
                  <span class="parrafo-2 font-weight-600">Continuar</span>
                </v-btn>


                <v-btn
                    v-if="evaluation.estadoMedicionAsignada == 0"
                    dark 
                    class="primary-btn text-capitalize text-right"
                    target="_blank"
                    >
                <span class="parrafo-2 font-weight-600">Proximamente</span>

              </v-btn>


            </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  props: {
    evaluation: Object
  },
  methods: {
    ...mapActions({
      fetchEvaluations: "fetchEvaluations"
    }),
    ...mapGetters({
      institucionId: "getInstitutionId",
      user: "getUserData",
      urlApi: "getEvaluacionesUrlApi",
      pollApi: "getPollUrlApi"
    }),
    getURLtoRedirect(evaluation){
      if(evaluation.contextoAcademico == 0){
        return this.urlApi()+'init?i='+this.institucionId()+'&ma=' + evaluation.idMedicionAsignada;
      }else{
        return this.pollApi()+'?i='+this.institucionId()+'&m='+evaluation.idMedicion+'&ma='+evaluation.idMedicionAsignada;
      }
    },
    textCapitalize(value){
      let aux = value.trim().split(' ');
      aux = aux.filter( element => element != '');
      aux = aux.map( (word, index) => {
        word = word.trim();
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      })
      return aux.join(' ');
    },
    formatDate(date) {
      // const { personId, section, institutionContext } = this.user();
      return moment(date).format("DD/MM/YYYY");
    },
    capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
  }
};
</script>
<style lang="scss">
@import '../../assets/styles/generals.scss';

$fixed-size: 3px;
.roma-card {
  position: relative;

  &__title{
    // color: rgb(220, 27, 27);
    cursor: pointer;
  }

  .pendiente-bg{
    background-color: #F5F9FC !important;
    pointer-events: none;
  }
  .en-progreso-bg{
    background-color: rgba(251, 140, 0, 0.05) !important;
    pointer-events: none;
  }
  .completa-evaluada-bg{
    background-color: rgba(0, 186, 52, 0.05) !important;
    pointer-events: none;
  }

  // .dropdown-wrapper {
  //   position: relative;
  //   .card-dropdown {
  //     top: 0;
  //     left: 50%;
  //     transform: translate(-50%, -50%);
  //     position: absolute;
  //   }
  // }
  // .btn-edit {
  //   .v-btn__content {
  //     font-size: 14px;
  //   }
  // }
  // &__custom-container {
  //   display: grid;
  //   align-items: baseline;
  //   grid-template-rows: max-content max-content 1fr max-content;
  // }
  .card-container-footer {
    position: absolute;
    bottom: 10px;
    left: 18px;
    right: 10px;
  }
  .loading-card {
    height: 250px;
  }
  .middle {
    margin-top: 20px;
  }
}

</style>
